module.exports = __webpack_public_path__ + "img/kam.b1552e4d.webp";